import { Fragment } from "react";
import { ToolIcon } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
const GroupingToolsComposite = () => {
  return (
    <Fragment>
      <ToolIcon name={"object-group"} title={appstr("group")} />
      <ToolIcon name={"distribute-spacing-vertical"} title={appstr("Distribute Space Vertical")} />
      <ToolIcon name={"objects-align-top"} title={appstr("Align Objects Top")} />
      <ToolIcon name={"send-back"} title={appstr("Send Back")} />
      <ToolIcon name={"thumbtack"} title={appstr("Pin")} />
    </Fragment>
  );
};

export default GroupingToolsComposite;
